import React from 'react';
import OuiNonToggle from './oui-non-toggle.js';
import { ARMES_CHASSE } from '../../enums/armes-chasse.js';
import {
  quantiteCaptureRapporteeCompletee,
  quantiteCaptureConsommeeCompletee,
} from '../../utils/fermer-enregistrement-chasse-capture.js';

const clampQuantity = (rawValue) => {
  if (rawValue === '' || rawValue === null || rawValue === undefined) {
    return '';
  }
  const n = Number(rawValue);
  if (Number.isNaN(n)) {
    return '';
  }
  if (n < 0) {
    return '0';
  }
  if (n > 999) {
    return '999';
  }
  return String(Math.floor(n));
};

const formatDisplayValue = (value) => {
  if (value === '' || value === null || value === undefined) {
    return '';
  }
  if (Number(value) === 0) {
    return '';
  }
  return value;
};

const QuantityField = ({ label, value, onChange }) => (
  <div className="fec-capture-field-row">
    <span className="fec-capture-field-label">{label}</span>
    <input
      type="number"
      min="0"
      max="999"
      step="1"
      className="fec-capture-input"
      value={formatDisplayValue(value)}
      onChange={e => onChange(clampQuantity(e.target.value))}
      onWheel={(e) => e.currentTarget.blur()}
    />
  </div>
);

const QuestionBlock = ({ toggle, fields = null }) => (
  <div className="fec-capture-question-block">
    {toggle}
    {fields ?
      <div className="fec-capture-question-fields">
        {fields}
      </div>
      : null
    }
  </div>
);

const isToggleAnswered = (value) => value !== null && value !== undefined;

const ChasseCaptureQuestionsForm = ({ texts, detail, onChange }) => {
  const showConsommee = isToggleAnswered(detail.aCaptureRapportee)
    && quantiteCaptureRapporteeCompletee(detail);
  const showAbattage = showConsommee && isToggleAnswered(detail.aCaptureConsommee)
    && quantiteCaptureConsommeeCompletee(detail);

  return (
    <div className="fec-capture-questions fec-capture-species-card">
      <div className="fec-capture-species-title">
        <span className="droit-acces-span">{detail.descriptionEspece}</span>
      </div>

      <div className="fec-capture-questions-body">
        <QuestionBlock
          toggle={
            <OuiNonToggle
              texts={texts}
              label={texts.questionCaptureRapportee}
              value={detail.aCaptureRapportee}
              onChange={value => onChange('aCaptureRapportee', value)}
            />
          }
          fields={detail.aCaptureRapportee === true ?
            <QuantityField
              label={texts.labelQuantite}
              value={detail.nombreCaptureRapportee}
              onChange={value => onChange('nombreCaptureRapportee', value)}
            />
            : null
          }
        />

        {showConsommee &&
          <QuestionBlock
            toggle={
              <OuiNonToggle
                texts={texts}
                label={texts.questionCaptureConsommee}
                value={detail.aCaptureConsommee}
                onChange={value => onChange('aCaptureConsommee', value)}
              />
            }
            fields={detail.aCaptureConsommee === true ?
              <QuantityField
                label={texts.labelQuantite}
                value={detail.nombreCaptureConsommee}
                onChange={value => onChange('nombreCaptureConsommee', value)}
              />
              : null
            }
          />
        }

        {showAbattage &&
          <div className="fec-capture-question-block">
            <div className="sub-title-section">
              <span className="droit-acces-span">{texts.questionAbattage}</span>
            </div>
            <div className="fec-capture-question-fields">
              <div className="fec-capture-field-row">
                <select
                  className="fec-capture-input fec-capture-input-select"
                  value={detail.arme || ''}
                  onChange={e => onChange('arme', e.target.value)}
                >
                  <option value="">{texts.chooseOption}</option>
                  {ARMES_CHASSE.map(option => (
                    <option key={option} value={option}>{option}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        }

        {showAbattage &&
          <div className="fec-capture-question-block fec-capture-question-block--divers">
            <div className="fec-capture-group-title">{texts.groupDivers}</div>
            <div className="fec-capture-question-fields fec-capture-question-fields--inline">
              <div className="fec-capture-field-row">
                <span className="fec-capture-field-label">{texts.labelNoPermis}</span>
                <input
                  type="text"
                  className="fec-capture-input fec-capture-input-text"
                  value={detail.noPermis || ''}
                  onChange={e => onChange('noPermis', e.target.value)}
                />
              </div>
              <div className="fec-capture-field-row">
                <span className="fec-capture-field-label">{texts.labelNoCertificat}</span>
                <input
                  type="text"
                  className="fec-capture-input fec-capture-input-text"
                  value={detail.noCertificat || ''}
                  onChange={e => onChange('noCertificat', e.target.value)}
                />
              </div>
              <div className="fec-capture-field-row">
                <span className="fec-capture-field-label">{texts.labelRemarque}</span>
                <input
                  type="text"
                  className="fec-capture-input fec-capture-input-text"
                  value={detail.remarques || ''}
                  onChange={e => onChange('remarques', e.target.value)}
                />
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  );
};

export default ChasseCaptureQuestionsForm;
